import React from 'react'
import { useSync } from '~/hooks/server/sync'

import { ChildProps } from '~/common/define/props'
import AppLayout from '~/components/layout/AppLayout'
import PublicHeader from '~/components/molecules/header/public/PublicHeader'
import PublicFooter from '~/components/atoms/footer/PublicFooter'
import CopyRightFooter from '~/components/atoms/footer/CopyRightFooter'

const AppStandardLayout = ({children}: ChildProps) => {
  const {error} = useSync()

  return (
    <AppLayout reqError={error}>
      <PublicHeader/>
        {children}
      <PublicFooter/>
      <CopyRightFooter/>
    </AppLayout>
  )
}

export default AppStandardLayout